import React from 'react';
import { Button } from 'antd';
import 'antd-mobile/dist/antd-mobile.css';
import { getUrlParam } from '../../utils/commonUtils';

class NoAuthPage extends React.Component {

    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        document.title = '没有权限';
    }

    onClick() {
        localStorage.removeItem('token');
        localStorage.removeItem('sessionId');
        let page = getUrlParam(this.props.location.search, 'page');
        if (page === undefined || page === null || page === '') {
            window.location.reload();
        } else {
            window.location.href = page;
        }
    }

    render() {
        return (
            <div style={{ height: '100%', backgroundColor: '#FFFFFF', padding: 20 }}>
                <div>
                    您没有访问当前页面的权限，如有疑问请联系量化小子的老板：金老板
                </div>
                <Button style={{ marginTop: 20 }} type="primary" onClick={this.onClick}>重新登录</Button>
            </div>
        );
    }

}

export default NoAuthPage;


// WEBPACK FOOTER //
// ./src/page/mobile/NoAuthPage.jsx